import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const BorderBottomStyle: React.CSSProperties = {
  height: toPx(sharedStyles.BorderWidth.SMALL),
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  backgroundColor: sharedStyles.Colors.Tints.NEUTRAL[5],
}

export const BorderBottomLastStyle: React.CSSProperties = {
  ...BorderBottomStyle,
  marginBottom: toPx(0),
}

export const ConditionGroupWrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * -1),
}

export const ConditionListWrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  marginRight: toPx(sharedStyles.Spacings.NORMAL),
}

export const EmptyConditionsLabelStyle: React.CSSProperties = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
}

export const ConditionListStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const NextStepStyle: React.CSSProperties = {
  margin: 0,
}
